// Teller Online Files
import { PublicHelpTag } from 'apps/public-portal/src/app/shared/help/help-tags';
import { helpTitle } from 'apps/public-portal/src/app/shared/help/help-titles';

// Teller Online Library Files
import { HelpArticle, HelpConditional } from 'teller-online-libraries/help';

export const PAYMENT_HISTORY_HELP_ARTICLES: HelpArticle[] = [
    new HelpArticle({
        tag: PublicHelpTag.PaymentHistory,
        order: 16,
        conditions: [HelpConditional.Users],
        bookmark: 'view-previous-payments',
        title: helpTitle('view-previous-payments'),
        body: '<p>Your payment history lists all of your previous transactions. Click on a '
            + 'transaction to show further details.</p> <p>Click on the <b>Download Receipt</b> '
            + ':receipt_long: button in the details to download a copy of the receipt.</p>'
    })
];
